import { useAjax } from "Services/useAjax";
import { AdminPostModel, DEFAULT_ADMIN_POST_MODEL, DynamicSettings } from "./DynamicSettings";
import { html } from "lit-html";
import { useState } from "Shared/haunted/CustomHooks";
import classNames from "classnames";

export interface Props {
	newSettings: DynamicSettings;
	validate?: () => boolean;
}

export const useSaveDynamicSettings = (props: Props) => {
	const { ajaxRequest } = useAjax();

	const [isLoading, setIsLoading] = useState<boolean>(false);

	const startLoading = () => {
		setIsLoading(true);
		const loaderInstance = window.newRtLoader(".main-wrap");
		loaderInstance.startLoader();
		return loaderInstance;
	};

	const stopLoading = (loader: LoaderInstance) => {
		setIsLoading(false);
		if (!loader) return;
		loader.stopLoader();
		loader.destroy();
	};

	const save = async (e: MouseEvent) => {
		e.preventDefault();
		e.stopPropagation();

		if (typeof props.validate === "function" && !props.validate()) return;

		const loader = startLoading();

		try {
			const body: AdminPostModel = {
				...DEFAULT_ADMIN_POST_MODEL,
				...props.newSettings,
				ActionType: "save_dynamic_settings",
			};

			await ajaxRequest({ body, url: "/samuraijack" });
			window.location.reload();
		} catch (error) {
			stopLoading(loader);
			alert("An error occurred while saving dynamic settings: " + (error as Error).message);
		}
	};

	const htmlTemplate = () => html`
		<div class="mt-10 flex w-full items-center justify-end gap-8">
			<div class="text-sm text-n-red">
				* After saving, a page refresh (F5) may be necessary to properly reflect the saved state.
			</div>
			<button
				type="submit"
				class=${classNames("bg-n-blue", "hover:bg-n-red hover:text-white", {
					"pointer-events-none opacity-50": isLoading,
				})}
				value="Invalidate"
				@click=${save}
			>
				Save Dynamic Settings
			</button>
		</div>
	`;

	return { htmlTemplate };
};
